import React from "react";

export const newsItems = [
    {
        title: "Language models: ",
        description: "Integrating protein language models and automatic biofoundry for enhanced protein evolution",
        imageUrl: "https://media.springernature.com/full/springer-static/image/art%3A10.1038%2Fs41467-025-56751-8/MediaObjects/41467_2025_56751_Fig2_HTML.png?as=webp",
        link: "https://www.nature.com/articles/s41467-025-56751-8"
    },
    {
        title: "AI biology model: ",
        description: "An artificial-intelligence network trained on a vast trove of sequence data is a step towards designing completely new genomes.",
        imageUrl: "https://media.nature.com/lw767/magazine-assets/d41586-025-00531-3/d41586-025-00531-3_50658630.jpg?as=webp",
        link: "https://www.nature.com/articles/d41586-025-00531-3"
    },
    {
        title: "COVID-19’s Origins: ",
        description: "AI Uncovers Hidden Genetic Clues That Challenge COVID-19’s Origins.",
        imageUrl: "https://scitechdaily.com/images/Genetic-DNA-Sequence-1536x1024.jpg",
        link: "https://scitechdaily.com/ai-uncovers-hidden-genetic-clues-that-challenge-covid-19s-origins/"
    },
    {
        title: "Energy costs for sustainable AI: ",
        description: " Researchers have developed a novel method that predicts AI costs, allowing users to make informed decisions about when to update AI models to improve AI sustainability.",
        imageUrl: "https://imageio.forbes.com/specials-images/imageserve/63bdffc05989c30c33964a41/Artificial-Intelligence/960x0.png?format=png&width=1440",
        link: "https://www.sciencedaily.com/releases/2025/01/250113134205.htm"
    },
    {
        title: "Meet SQUID: ",
        description: "A new genomic AI model",
        imageUrl: "https://media.npr.org/assets/img/2020/07/30/20200729-4-squid-tentacle-doryteuthis-pealeii-credit-karen-crawford_custom-cf71f6b170cc9e9ad28abffe1dd3a6d8d88ffb0b.jpg?s=1600&c=85&f=webp",
        link: "https://www.sciencedaily.com/releases/2024/06/240621122906.htm"
    },
    {
        title: "3D image segmentation network: ",
        description: "Based on gated attention blocks and dual-scale cross-attention mechanism.",
        imageUrl: "https://media.springernature.com/lw685/springer-static/image/art%3A10.1038%2Fs41598-025-90339-y/MediaObjects/41598_2025_90339_Fig1_HTML.png?as=webp",
        link: "https://www.nature.com/articles/s41598-025-90339-y"
    },
    {
        title: "2024 Bioinformatics Student Awards",
        description: "                                                                             ",
        imageUrl: "https://bioinformatics.gatech.edu/sites/default/files/Hg_News/Shivam.Sharma_Anagha.M.Krishna.png",
        link: "https://bioinformatics.gatech.edu/index.php/2024-bioinformatics-outstanding-student-awards"
    },
    {
        title: "Electronic Health Record Systems",
        description: "Impact of Quantum Computing on Blockchain systems",
        imageUrl: "https://openbioinformaticsjournal.com/contents/volumes/V17/e18750362316814/e18750362316814_F1.jpg",
        link: "https://openbioinformaticsjournal.com/VOLUME/17/ELOCATOR/e18750362316814/FULLTEXT/"
    }
];

const NewsPage = () => {
    return (
        <div className="min-h-screen flex flex-col bg-gradient-to-br from-blue-900 via-purple-900 to-indigo-900">
            <div className="flex-grow mt-24 md:mt-10 px-4">
                <h1 className="text-xl md:text-3xl font-bold text-white text-center pt-8 md:pt-16 pb-4 md:pb-8">
                    Latest Technology News
                </h1>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6 lg:gap-8 pb-8 md:pb-12">
                    {newsItems.map((item, index) => (
                        <a
                            key={index}
                            href={item.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="bg-white/20 backdrop-blur-lg border border-white/30 rounded-lg overflow-hidden shadow-xl transform transition-all duration-300 hover:scale-105 flex flex-col h-full"
                        >
                            <div className="aspect-w-16 aspect-h-9 relative">
                                <img
                                    src={item.imageUrl}
                                    alt={item.title}
                                    className="w-full h-48 sm:h-40 md:h-48 object-cover"
                                />
                            </div>
                            <div className="p-3 md:p-4 flex-grow flex flex-col ">
                                <h3 className="text-sm md:text-base font-semibold text-white mb-2">
                                    {item.title}
                                </h3>
                                <p className="text-xs md:text-sm text-white/80 line-clamp-3">
                                    {item.description}
                                </p>
                            </div>
                        </a>
                    ))}
                </div>
            </div>
        </div>
    );
};


export default NewsPage;